<template>

  <div class="row">
	 
    <div class="col-xl-12">
      <h4 class="title">Billing</h4>
      <p class="category">
      List of unpaid billings.
      </p>
    </div>
    
    
    
        <div class="card">
   		
          <div class="card-body table-responsive table-full-width">
          	
			<el-table :data="invoices" @row-click="goEditInvoice">
			 <el-table-column label="Company" property="entity_name"  min-width=200></el-table-column>
             <el-table-column label="Billing ID" property="id"  min-width=140></el-table-column>
            <!-- <el-table-column label="Created" property="created_at_str"  min-width=140></el-table-column>-->
                <el-table-column label="Title" property="title" min-width=240></el-table-column>
                <el-table-column label="Amount" property="amount_str" min-width=140>
                	<template slot-scope="scope">
           				{{scope.row.amount_str}} {{scope.row.currency}}

          			</template>
                </el-table-column>
                <el-table-column label="Due Date" property="deadline_str" sortable min-width=140></el-table-column>
                  <el-table-column label="Payment" min-width=140>
                 	<template slot-scope="scope">
           				 <span v-if="scope.row.status===1">Not Paid</span>
           				 <span v-if="scope.row.status===2">Paid</span>
						 <span v-if="scope.row.status===3">Cancelled</span>
          			</template>
                 </el-table-column>	
            </el-table>
				
				
				
          </div>
        </div>
        
        
    
   
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    
    data () {
      return {
      	invoices:[],
      	tableTd:'',

      
      }
    },
    mounted() {
    	  swal.showLoading();
     	  let uri = this.$base_url+'/api/v1/accounting/get/invoices';
		  ApiService.get(uri).then(response => {
		  		this.invoices = response.data.invoices;
		  		 swal.close();
		  
		  });
    },
    methods: {
      goEditInvoice(row){
      	 var tid = 0;
      	 if(row.task_id){
      	 	tid = row.task_id
      	 }
      	 this.$router.push( '/edit-invoice/'+row.id+'/entity/'+row.entity_id+"/task/"+tid)  
      },
      
    }
  }
</script>
<style lang="scss">

  
</style>
